import React from 'react';
import { CivilDate } from 'tc39-proposal-temporal';
import { WaterfallFilterType } from '@bingads-webui-campaign/filter-storage';
import { DatePickerWithScope } from '../date-picker/index';

export const useDatePicker = (props) => {
  const {
    minDate, i18n, serverContext, disableCompare, perfMetricDateRange, updateWaterfallFilter,
  } = props;
  const renderDatePicker = () => {
    const civilMinDate = minDate ? new CivilDate(minDate.year, minDate.month, minDate.day) : minDate;
    const DatePickerWithPageReady = () => (
      <div className="pickerContainerPartClassName">
        <DatePickerWithScope
          i18n={i18n}
          lcid={serverContext.CurrentUser.LocaleID}
          timeZone={serverContext.CurrentAccount.TimeZone}
          dateFormat={serverContext.CurrentUser.CultureDateTimeFormat.ShortDatePattern}
          dateFilter={perfMetricDateRange}
          // onSwitchCompare={this.onSwitchCompare}
          disableCompare={disableCompare}
          updateWaterfallFilter={data => updateWaterfallFilter({
            filterType: WaterfallFilterType.DateFilter,
            filter: data,
          })}
          serverContext={serverContext}
          minDate={civilMinDate}
        />
      </div>
    );

    return (<DatePickerWithPageReady />);
  };

  return { renderDatePicker };
};
